import React, {useEffect, useState} from "react";
import Modal from "../../hooks/modal";
import useModal from "../../hooks/useModal";
import {useStateValue} from "../../states/StateProvider";
import Api from "../../Api/api";
import {useParams} from "react-router";
import {toast} from "react-toastify";
import {AES, enc} from "crypto-js";
import {ClipLoader} from "react-spinners";
import UpdateUpselling from "../../components/modal/updateUpselling";
import Status from "../milestones/partial/status";
import {useNavigate} from "react-router-dom";
import Services from "./partial/Services";
import CompanyData from "../milestones/partial/companyData";
import CompanyInfoPopUpDGGEdit from "../../components/modal/companyInfoPopUpDGGEdit";
import CompanyInfoPopUpEdit from "../../components/modal/companyInfoPopUpEdit";

const Reporting = () => {
    const [{
        companyInfoModal,
        upsellingModal,
        secretKey,
        upsellingSaved,
        noteSent,
        noteRows,
        remindersSaved
    }, dispatch] = useStateValue();
    const {toggleCompanyInfoModal, toggleUpsellingModal} = useModal();
    const [stepsLoading, setStepsLoading] = useState(true)
    const [userValidated, setUserValidated] = useState(false)
    const [userCheckCompleted, setUserCheckCompleted] = useState(false)
    const [info, setInfo] = useState(null)
    const [edit, setEdit] = useState(false)
    const [editInfo, setEditInfo] = useState('')
    const [editInfoFull, setEditInfoFull] = useState('')
    const [editID, setEditID] = useState(1)
    const [data, setData] = useState([])
    const [options, setOptions] = useState([])
    const [infoLoading, setInfoLoading] = useState(false)
    const [companyName, setCompanyName] = useState('')
    const param = useParams()
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const [showEdit, setShowEdit] = useState(false);

    const [notes, setNotes] = useState([])
    const [notesCount, setNotesCount] = useState(7)
    const [loadingNotes, setLoadingNotes] = useState(false)
    const navigate = useNavigate()

    const role = user.role

    const handleClick = async () => {
        setInfoLoading(true)
        let data = new FormData()
        data.append('userId', user.fullname)
        data.append('portal', param.portal)
        data.append('company', param.id)

        Api().post(`/upsellingFreischaltenEmail`, data).then(res => {
            setInfoLoading(false)
            toast.success('Email wurde erfolgreich versendet.')
        }).catch(e => {
            setInfoLoading(false)
            toast.error('Etwas ist schief gelaufen!')
        })
    };

    useEffect(() => {
        let data = new FormData()
        data.append('user', user.ID)
        data.append('fp', param.id)
        data.append('portal', param.portal)
        Api().post(`/validateUserToFp`, data).then(res => {
            if(res.data === 1) {
                setUserValidated(true)
            } else {
                setUserValidated(false)
                toast.error('Sie haben keinen Zugang zu der Seite!')
                setTimeout(() => navigate('/dashboard'), 2000)

            }
            setStepsLoading(true)
            setUserCheckCompleted(true)
        }).catch(e => {
            setUserValidated(false)
            setStepsLoading(false)
            setUserCheckCompleted(true)
            toast.error('Dienstleistungen konnten nicht geladen werden!')
        })
    }, []);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setLoadingNotes(true)
            Api().get(`/getNotes/${param.portal}/${param.id}/${noteRows}`).then(res => {
                setNotes(res.data)
                setNotesCount(res.data[0]?.total)
                setLoadingNotes(false)
            }).catch(e => {
                setLoadingNotes(false)
                toast.error('Notizen konnten nicht geladen werden!')
            })
        }
    }, [userCheckCompleted, noteRows, noteSent, remindersSaved]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setStepsLoading(true)
            setInfoLoading(true)
            Api().get(`/customerDetails/${param.portal}/${param.id}`).then(res => {

                setInfo(res.data[0])
            }).catch(e => {
                toast.error('Firmendetails konnten nicht geladen werden!')
            })

            setInfoLoading(false)

            Api().get(`sp_getUpsellingOptions/${'dgg'}`)
                .then(res => {
                    setOptions(res.data)
                })
        }
    }, [userCheckCompleted]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setStepsLoading(true)
            setInfoLoading(true)
            Api().get(`/sp_getDataCustUpselling/${param.portal}/${param.id}`).then(res => {
                setCompanyName(res.data.companyName)
                const sortedOptions = res.data.data.sort((a, b) => {
                    return a.FP_ID - b.FP_ID;
                });

                setData(sortedOptions[0])
                setStepsLoading(false)
            }).catch(e => {
                toast.error('Firmendetails konnten nicht geladen werden!')
                setStepsLoading(false)
            })
            setInfoLoading(false)
        }
    }, [userCheckCompleted, upsellingSaved]);

    function setEditStates(u, index) {
        if (u[1].split(',')[0] !== 'Vertrag aktiv' && u[1].split(',')[0] !== 'Vertrag inaktiv') {
            setEditInfo(u[1].split(',')[0])
            setEditInfoFull(u)
            setEditID(index + 1)
            setEdit(true)
            toggleUpsellingModal()
        }
    }

    const style = {
        height: '55vh',
    };
    return (
        <div className='dashboardContainer'>
            <CompanyData info={info}
                         company={companyName}
                         companyID={param.id}
                         portal={param.portal}
                         loading={infoLoading}
                         toggle={toggleCompanyInfoModal}
                         toggleEdit={setShowEdit}
                         user={user}
                         showUpselling={true}
            />
            {
                stepsLoading &&
                <tr className='centerItemsAbsolute'>
                    <td><ClipLoader size={50} color={'#b4b4b4'}/></td>
                </tr>
            }
            {
                !stepsLoading &&
                <div className='lg:flex justify-between my-3 rounded-lg sm:block'>
                    <Services
                        data={data}
                        handleClick={handleClick}
                        setEditStates={setEditStates}
                        FPID={param.id}
                    />
                    <div className='bg-white mt-4 px-3 pb-10 2xl:w-7/12 w-full sm:block ml-3 rounded-lg min-h-full'>
                        <Status company={companyName}
                                companyID={param.id}
                                portal={param.portal}
                                notes={notes}
                                role={role}
                                loadingNotes={loadingNotes}
                                count={notesCount}
                                showReminderSection={true}
                        />
                    </div>

                </div>

            }

            {param.portal === 'dgg' ?
                <CompanyInfoPopUpDGGEdit
                    portal={param.portal}
                    company={param.id}
                    companyName="Test GmbH"
                    show={showEdit}
                    toggle={setShowEdit}
                /> :
                <CompanyInfoPopUpEdit
                    portal={param.portal}
                    company={param.id}
                    companyName={companyName}
                    show={showEdit}
                    toggle={setShowEdit}
                />
            }
            <Modal toggle={toggleUpsellingModal}
                   visible={upsellingModal}
                   small
                   component={<UpdateUpselling FPID={param.id} editID={editID} options={options} dataFull={editInfoFull}
                                               data={editInfo}
                                               toggle={toggleUpsellingModal}/>}
            />
        </div>
    )
}

export default Reporting
